module.exports = __webpack_public_path__ + "img/shangchen.d532a992.png";